import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from "@angular/core";
import {UserSubscription} from "../../../../../../user/user-subscription";
import {OneMonthFreeStep} from "../../one-month-free.component";
import {DbActiveModal} from "../../../../../../modules/modal/modal-ref";


interface IFeature {
  title: string;
  desc: any;
  src: string;
  firstFrame: string;
  duration: number;
  id: number;
}

@Component({
    selector: 'db-one-month-free-builder',
    templateUrl: './one-month-free-builder.component.html',
    styleUrls: ['./one-month-free-builder.component.scss'],
    standalone: false
})
export class OneMonthFreeBuilderComponent implements OnInit {

  @ViewChild('AiAssistantOnboardingFirstVideo') AiAssistantOnboardingFirstVideo: ElementRef<HTMLVideoElement>;
  @Input() currentSubscription: UserSubscription;
  @Input() step: number = 0;
  @Input() customDomainFlow: boolean;
  @Output() changeVideo = new EventEmitter<any>();
  @Output() onStepChange = new EventEmitter<OneMonthFreeStep>();
  public features: IFeature[];
  public activeFeature: number = 0;
  public aiAssistantStep: any;
  public firstVideoPoster: string;
  public firstVideoDuration: number = 16;
  public firstVideoSrc: string;
  public videoCurrentSecond: number = 0;
  public loading: boolean;
  public isMobile: boolean;
  private _simulationTimer: any;

  constructor(
    private readonly activeModal: DbActiveModal,
  ) { }

  ngOnInit() {
    this.activeModal.whiteCloseBtn(false);
    this.isMobile = window.innerWidth <= 991;
    this.aiAssistantStep = [
      {
        title: 'Drag & drop builder for effortless editing',
        src: 'assets/videos/drag-and-drop-video.mp4',
        firstFrame: 'assets/images/backgrounds/drag-and-drop-frame.jpeg',
        duration: 16,
        id: 0
      },
      {
        title: '50+ widgets to enhance your website',
        src: 'assets/videos/widgets-video.mp4',
        firstFrame: 'assets/images/backgrounds/widgets-frame.jpg',
        duration: 9,
        id: 1
      },
      {
        title: 'Responsive design for any screen size',
        src: 'assets/videos/responsive.mp4',
        firstFrame: 'assets/images/backgrounds/responsive-frame.jpg',
        duration: 12,
        id: 2
      },
      {
        title: 'Free custom domain up to $30',
        src: 'assets/videos/responsive.mp4',
        firstFrame: 'assets/images/backgrounds/responsive-frame.jpg',
        id: 3
      }
    ];
    this.features = [
      {
        title: 'Generate content for various use cases',
        desc: 'Choose from our selection of prompts for dozens of<br/>tailored use cases like creating blogpost intros, FAQs,<br/>outlines and more.',
        src: 'assets/videos/responsive.mp4',
        duration: 12,
        firstFrame: 'assets/images/backgrounds/responsive-frame.jpg',
        id: 0
      }
    ];
    this.firstVideoSrc = this.features.find((_feature) => _feature.id === this.activeFeature).src;
    this.firstVideoPoster = this.features.find((_feature) => _feature.id === this.activeFeature).firstFrame;
    this.firstVideoDuration = this.features.find((_feature) => _feature.id === this.activeFeature).duration;
    !this.isMobile && this.changeVideoSec();
  }

  public changeFeature(feature) {
    if (this.isMobile) {
      return;
    }
    this.videoCurrentSecond = 0;
    clearInterval(this._simulationTimer);
    this.changeCurrentVideo(feature);
    this.changeVideoSec();
  }

  public changeCurrentVideo(feature): void {
    this.videoCurrentSecond = 0;
    this.activeFeature = feature;
    this.firstVideoSrc = this.features.find((_feature) => _feature.id === feature)?.src;
    this.firstVideoPoster = this.features.find((_feature) => _feature.id === feature)?.firstFrame;
    this.firstVideoPoster = this.features.find((_feature) => _feature.id === feature)?.firstFrame;
    this.firstVideoDuration = this.features.find((_feature) => _feature.id === feature)?.duration;
    const videoInfo = {
      src: this.firstVideoSrc,
      poster: this.firstVideoPoster,
      duration: this.firstVideoDuration
    };
    this.changeVideo.emit(videoInfo);
  }

  public resizeToNormal(): void {
    this.activeModal.resize(600, 940);
  }

  public changeVideoSec(): void {
    this._simulationTimer = setInterval(() => {
      if (this.videoCurrentSecond < this.firstVideoDuration) {
        this.videoCurrentSecond = this.videoCurrentSecond + 1;
      }
      else {
        this.activeFeature = this.activeFeature === 2 ? 0 : this.activeFeature + 1;
        this.changeCurrentVideo(this.activeFeature);
      }
    }, 1000);
  }


}
